import UsersApi from '../services/UsersApi';
import * as actionTypes from './types';

const api = new UsersApi();

export function loadUsersList() {
  return {
    type: actionTypes.LOAD_USERS_LIST,
    payload: api.list()
  };
}


export function editUser(userId) {
  return {
    type: actionTypes.EDIT_USER,
    payload: api.edit(userId)
  };
}

export function setEditUserProperty(name, value) {
  return {
    type: actionTypes.SET_EDIT_USER_PROPERTY,
    payload: {name, value}
  };
}

export function cancelEditUser() {
  return {
    type: actionTypes.CANCEL_EDIT_USER
  };
}

export function updateUser(user) {
  return {
    type: actionTypes.UPDATE_USER,
    payload: api.update(user.toJS())
  };
}


export function showSetUserPassword(user) {
  return {
    type: actionTypes.SHOW_SET_USER_PASSWORD,
    payload: user
  };
}

export function setSetUserPasswordModelProperty(name, value) {
  return {
    type: actionTypes.SET_SET_USER_PASSWORD_MODEL_PROPERTY,
    payload: {name, value}
  };
}

export function cancelSetUserPassword() {
  return {
    type: actionTypes.CANCEL_SET_USER_PASSWORD
  };
}

export function setUserPassword(model) {
  return {
    type: actionTypes.SET_USER_PASSWORD,
    payload: api.setUserPassword(model.toJS())
  };
}


export function confirmDisableUser(user) {
  return {
    type: actionTypes.CONFIRM_DISABLE_USER,
    payload: user
  };
}

export function cancelDisableUser() {
  return {
    type: actionTypes.CANCEL_DISABLE_USER
  };
}

export function disableUser(userId) {
  return {
    type: actionTypes.DISABLE_USER,
    payload: api.disable(userId)
  };
}


export function confirmEnableUser(user) {
  return {
    type: actionTypes.CONFIRM_ENABLE_USER,
    payload: user
  };
}

export function cancelEnableUser() {
  return {
    type: actionTypes.CANCEL_ENABLE_USER
  };
}

export function enableUser(userId) {
  return {
    type: actionTypes.ENABLE_USER,
    payload: api.enable(userId)
  };
}



// WEBPACK FOOTER //
// ./app/features/users/actions/creators.js